var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import classnames from "classnames";
import "./groupInput.less";
var GroupInput = /** @class */ (function (_super) {
    __extends(GroupInput, _super);
    function GroupInput(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (e) {
            var onChange = _this.props.onChange;
            var value = (e && e.target) ? e.target.value : e;
            onChange(value);
        };
        return _this;
    }
    GroupInput.prototype.focus = function () {
        this.dom && this.dom.focus();
    };
    GroupInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, required = _a.required, component = _a.component, error = _a.error, message = _a.message, wrapClassName = _a.wrapClassName, prop = _a.prop;
        return (React.createElement("div", { className: classnames("form-group", wrapClassName, error && "has-error") },
            label && (React.createElement("label", null,
                label,
                " ",
                required && "*")),
            (component &&
                React.cloneElement(component, __assign(__assign({}, this.props), { onChange: this.onChange, ref: function (dom) {
                        _this.dom = dom;
                    } }))) || (React.createElement("input", __assign({ id: prop, type: "text", className: "form-control input-sm", ref: function (dom) {
                    _this.dom = dom;
                } }, this.props, { onChange: this.onChange }))),
            error && React.createElement("label", { className: "text-danger " }, error),
            message && message));
    };
    return GroupInput;
}(React.Component));
export default GroupInput;
